module.exports = __webpack_public_path__ + "img/pic16.9bf0febc.png";